<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header header-elements-inline">
          <h5 class="card-title">Daily Time Cards</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="offset-lg-2 col-lg-4 col-md-4 sol-sm-12">
              <div class="form-group">
                <label>Date:</label>
                <el-date-picker
                  v-model="searchDate"
                  type="date"
                  align="right"
                  unlink-panels
                  format="MMM dd, yy"
                  @change="setShowNoTimeCardMessage"
                >
                </el-date-picker>
                <div v-if="searchDateError">
                  <span>{{ searchDateMessage }}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 sol-sm-12">
              <div class="form-group">
                <label>Employee (optional):</label>
                <!-- this needs to be a ddl of employees -->
                <v-select
                  :options="users"
                  label="name"
                  v-model="selectedEmployee"
                ></v-select>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-6">
              <el-switch
                style="display: block"
                v-model="showApprovedCards"
                active-color="#13ce66"
                inactive-color="#ad466c"
                active-text="Show Approved Time Cards"
                active-value="true"
                @change="updateApprovedFlag"
              >
              </el-switch>
            </div>
            <div class="col-6">
              <div class="col-12">
                <div class="text-right">
                  <button
                    type="button float-right"
                    class="btn btn-primary mr-2"
                    v-bind:disabled="selectedEmployee == null"
                    v-on:click="addTimeCard"
                  >
                    Add Time Card<i class="icon-plus3 ml-2"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="searchCards"
                  >
                    Search<i class="icon-search4 ml-2"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <timeCard
      v-for="(timeCard, index) in timeCardCollection"
      v-bind:key="index"
      v-bind:index="index"
      v-bind:id="timeCard.id"
      v-bind:date="timeCard.date"
      v-bind:approved="timeCard.approved"
      v-bind:times="timeCard.times"
      v-bind:name="timeCard.name"
      v-bind:type="timeCard.type"
      v-bind:dateApproved="timeCard.dateApproved"
      v-bind:lastRegTime="lastRegTime"
      v-bind:otIndex="otIndex"
      v-bind:approvedBy="timeCard.approvedBy"
      v-bind:timeSpanTypes="timeSpanTypes"
      v-bind:holidays="holidays"
      v-bind:vacation="timeCard.vacation"
      v-bind:uid="timeCard.uid"
      v-bind:showLocation="true"
      v-bind:passedEditComment="timeCard.editComment"
      :averagingAgreement="
        timeCard.averagingAgreement ? timeCard.averagingAgreement : null
      "
      :users="users"
      ref="timeCardCollection"
      @deleteTimeCard="deleteTimeCard"
    ></timeCard>

    <!-- //If no time cards are available for the selected time, show message, message will disappear upon selection of new date via the showNoTimeCardMessage variable that changes to false upon selection of new date, and true upon clicking the search button -->

    <h3
      :showNoTimeCardMessage="showNoTimeCardMessage"
      v-if="
        timeCardCollection &&
          showNoTimeCardMessage &&
          timeCardCollection.length === 0
      "
    >
      There are no time cards available for the time selected
    </h3>

    <!-- Add Time Card Modal -->
    <add-time-card
      v-if="showAddTimeCardModal"
      v-bind:showModal="showAddTimeCardModal"
      :selectedEmployee="selectedEmployee"
      :searchDate="searchDate"
      @closeAddModal="closeAddModal"
      @reloadCards="searchCards"
    />
    <!-- /Add Time Card Modal -->
  </div>
</template>

<script>
import timeCard from '../components/timeCard.vue';
import addTimeCard from '../components/addTimeCardModal.vue';

import { db } from '../assets/js/firebase/db.js';
import moment from 'moment';
import { getHolidays } from '../assets/js/helpers/holidays.js';

export default {
  name: 'dailyTimeCards',
  components: {
    timeCard,
    addTimeCard
  },
  data() {
    return {
      timeCardCollection: null,
      lastRegTime: null,
      otIndex: null,
      users: [],
      timeSpanTypes: [],
      selectedEmployee: null,
      searchDate: null,
      searchDateError: false,
      searchDateMessage: null,
      showApprovedCards: true,
      showAddTimeCardModal: false,
      showNoTimeCardMessage: false,
      holidays: []
    };
  },
  methods: {
    setShowNoTimeCardMessage: function() {
      this.showNoTimeCardMessage = false;
    },
    searchCards: function() {
      if (this.validateSearch() == true) {
        //create the query based off of the selections.
        let modifiedDate = moment(this.searchDate);
        //get the list of holidays for the year that the user has selected.
        getHolidays(moment(modifiedDate).format('YYYY'))
          .then(response => {
            for (
              let i = 0;
              i <= response.data.provinces[0].holidays.length - 1;
              i++
            ) {
              this.holidays.push(response.data.provinces[0].holidays[i].date);
            }
          })
          .catch(() => {
            console.log(`Error getting holidays`);
          });
        let query = db
          .collection('timeCards')
          .where('date', '>=', this.searchDate)
          .where(
            'date',
            '<=',
            moment(this.searchDate)
              .endOf('day')
              .toDate()
          )
          .where('company', '==', this.$store.state.userCompany);
        if (this.selectedEmployee != null) {
          query = query.where('user', '==', this.selectedEmployee.id);
        }
        if (this.showApprovedCards == false) {
          query = query.where('approved', '==', false);
        }
        this.timeCardCollection = [];
        //run out to the store and grab a pack of time cards.
        query
          .get()
          .then(querySnapshot => {
            let tempArg = [];
            querySnapshot.forEach(doc => {
              let complete = true;
              for (let i = 0; i <= doc.data().times.length - 1; i++) {
                if (doc.data().times[i].endTime == null) {
                  complete = false;
                }
              }
              if (complete) {
                //only going to display time cards that have an end time on this.
                tempArg.push({
                  id: doc.id,
                  date: moment(doc.data().date.toDate()).format('MMM DD, YY'),
                  times: doc.data().times,
                  approved: doc.data().approved,
                  approvedBy:
                    doc.data().approvedBy == undefined
                      ? null
                      : doc.data().approvedBy,
                  name: doc.data().name,
                  type: doc.data().type,
                  dateApproved:
                    doc.data().dateApproved == undefined
                      ? null
                      : moment(doc.data().dateApproved.toDate()).format(
                          'MMM DD, YY hh:mm'
                        ),
                  vacation: doc.data().vacation,
                  uid: doc.data().user,
                  averagingAgreement: doc.data().averagingAgreement
                    ? doc.data().averagingAgreement
                    : null,
                  editComment:
                    doc.data().editComment != undefined
                      ? doc.data().editComment
                      : null
                });
              }
            });
            let sum = 0;
            for (let i = 0; i <= tempArg.length - 1; i++) {
              //itterate all of the times can get a total.
              let daysum = moment.duration();
              for (let t = 0; t <= tempArg[i].times.length - 1; t++) {
                tempArg[i].times[t] = {
                  times: [
                    // tempArg[i].times[t].startTime.toDate().toLocaleTimeString([], {month: '2-digit', day: '2-digit', year: '2-digit', hour: '2-digit', minute:'2-digit'}),
                    // tempArg[i].times[t].endTime.toDate().toLocaleTimeString([], {month: '2-digit', day: '2-digit', year: '2-digit', hour: '2-digit', minute:'2-digit'})
                    tempArg[i].times[t].startTime.toDate(),
                    tempArg[i].times[t].endTime.toDate()
                  ],
                  type: tempArg[i].times[t].type,
                  typeError: false,
                  typeMessage: null,
                  dateError: false,
                  dateMessage: null,
                  notes: tempArg[i].times[t].notes,
                  job: tempArg[i].times[t].job ? tempArg[i].times[t].job : null,
                  startLocation: {
                    latitude:
                      tempArg[i].times[t].startLocation != undefined
                        ? tempArg[i].times[t].startLocation.latitude
                        : null,
                    longitude:
                      tempArg[i].times[t].startLocation != undefined
                        ? tempArg[i].times[t].startLocation.longitude
                        : null
                  },
                  endLocation: {
                    latitude:
                      tempArg[i].times[t].endLocation != undefined
                        ? tempArg[i].times[t].endLocation.latitude
                        : null,
                    longitude:
                      tempArg[i].times[t].endLocation != undefined
                        ? tempArg[i].times[t].endLocation.longitude
                        : null
                  }
                };
                let start = moment(tempArg[i].times[t].startTime);
                let end = moment(tempArg[i].times[t].endTime);
                daysum.add(moment.duration(end.diff(start)).asHours());
              }
            }
            //this is the time card that will go over the weekly maximum
            this.timeCardCollection = tempArg;
          })
          .catch(err => {
            console.log(err);
          });

        //change show no time card message to true upon click of search button
        this.showNoTimeCardMessage = true;
      }
    },
    updateApprovedFlag: function(val) {
      this.searchCards();
    },
    closeAddModal: function() {
      this.showAddTimeCardModal = false;
    },
    deleteTimeCard: function(index) {
      this.timeCardCollection.splice(index, 1);
    },
    showSuccess: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'success'
      });
    },
    showError: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'error'
      });
    },
    addTimeCard: function() {
      if (!this.searchDate) {
        const currentDate = new Date();

        currentDate.setHours(0, 0, 0, 0);

        this.searchDate = currentDate;
      }
      this.showAddTimeCardModal = true;
    },
    validateSearch: function() {
      let flag = true;
      if (this.searchDate == null) {
        this.searchDateError = true;
        this.searchDateMessage = 'The date selection cannot be empty.';
        flag = false;
      } else {
        this.searchDateError = false;
        this.searchDateMessage = null;
        flag = true;
      }
      return flag;
    }
  },
  mounted() {
    //get the user list.
    db.collection('users')
      .where('company', '==', this.$store.state.userCompany)
      .orderBy('name', 'asc')
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (this.$store.state.showInactiveEmployees == 'Yes') {
            this.users.push({
              id: doc.id,
              name: doc.data().name,
              averagingAgreement: doc.data().averagingAgreement
                ? doc.data().averagingAgreement
                : null,
              type: doc.data().type,
              userCategory: doc.data().userCategory
                ? doc.data().userCategory
                : null,
              vacation: doc.data().vacation
            });
          } else if (
            doc.data().deactiveDate == undefined ||
            doc.data().deactiveDate == null
          ) {
            this.users.push({
              id: doc.id,
              name: doc.data().name,
              averagingAgreement: doc.data().averagingAgreement
                ? doc.data().averagingAgreement
                : null,
              type: doc.data().type,
              userCategory: doc.data().userCategory
                ? doc.data().userCategory
                : null,
              vacation: doc.data().vacation
            });
          }
        });
      })
      .catch(err => {
        console.log(`Error getting users: ${err}`);
      });

    //get the time span types for the timecard edits.
    db.collection('timeSpanTypes')
      .orderBy('name', 'asc')
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.timeSpanTypes.push(doc.data().name);
        });
      })
      .catch(err => {
        console.log(`Error getting time span types: ${err}`);
      });
  }
};
</script>
